import { ColumnState } from 'ag-grid-community';
import { defaultMST4010_R01Dto, MST4010_R01Dto } from './Dto_MST4010_R01';
import { create } from 'zustand';

export interface MST4010_R01Filter {
	compCd: string;
	workplaceCd: string;
	equipmentType: string;
	equipmentCd: string;
}	

export interface Store_MST4010_R01 {
	MST4010_R01Filter: MST4010_R01Filter;
	MST4010_R01PastFilter: MST4010_R01Filter;
	setMST4010_R01Filter: (filter: Partial<MST4010_R01Filter>) => void;
	setMST4010_R01PastFilter: (filter: Partial<MST4010_R01Filter>) => void;

	MST4010_R01List: MST4010_R01Dto[];
	setMST4010_R01List: (MST4010_R01List: MST4010_R01Dto[]) => void;

	selectedMST4010_R01: MST4010_R01Dto | undefined;
	setSelectedMST4010_R01: (selectedMST4010_R01: MST4010_R01Dto | undefined) => void;
	initSelectedMST4010_R01: () => void;

	editMST4010_R01: MST4010_R01Dto;
	setEditMST4010_R01: (data: MST4010_R01Dto) => void;

	columnState: ColumnState[] | null;	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	initData: () => void;
}

export const defaultMST4010_R01Filter: MST4010_R01Filter = {
	compCd: '',
	workplaceCd: '',
	equipmentType: '',
	equipmentCd: ''
}

export const useMST4010_R01Store = create<Store_MST4010_R01>((set) => ({
	MST4010_R01Filter: defaultMST4010_R01Filter,
	MST4010_R01PastFilter: defaultMST4010_R01Filter,
	setMST4010_R01Filter: (filter) => set((state) => ({
		MST4010_R01Filter: {
			...state.MST4010_R01Filter,
			...filter
		}
	})),
	setMST4010_R01PastFilter: (filter) => set((state) => ({
		MST4010_R01PastFilter: {
			...state.MST4010_R01PastFilter,
			...filter
		}
	})),

	MST4010_R01List: [],
	setMST4010_R01List: (MST4010_R01List: MST4010_R01Dto[]) => set((state) => {
		return {
			...state,
			MST4010_R01List
		}
	}),

	selectedMST4010_R01: undefined,
	setSelectedMST4010_R01: (selectedMST4010_R01: MST4010_R01Dto | undefined) => set((state) => {
		return {
			...state,
			selectedMST4010_R01 : selectedMST4010_R01,
		}
	}),
	initSelectedMST4010_R01: () => set({ selectedMST4010_R01: undefined, editMST4010_R01: { ...defaultMST4010_R01Dto, valueIndex: 0 } }),
	
	editMST4010_R01: defaultMST4010_R01Dto,
	setEditMST4010_R01: (data: MST4010_R01Dto) => set((state) => {
		// console.log(data);
		let editMST4010_R01 = defaultMST4010_R01Dto;
		if (data) {
			editMST4010_R01 = {
				...data
			}
		}
		return { ...state, editMST4010_R01: editMST4010_R01 };
	}),

	columnState: null,		setColumnState: (state) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,			setAllCount: (allCount: number) => set({ allCount }),
				

	initData: () => set((state) => ({
		...state,
		MST4010_R01Filter: defaultMST4010_R01Filter,
		MST4010_R01PastFilter: defaultMST4010_R01Filter,
		MST4010_R01List: [],
		selectedMST4010_R01: undefined,
		editMST4010_R01: defaultMST4010_R01Dto,
		allCount: 0,
		scrollTop: null,
	})),
	
}));
